import Plyr from "plyr";
import {slider} from "./slider";

export const player = {
  /**
   * Init galleries if required
   */
    init: function () {
        const players = Array.from(document.querySelectorAll('.video-player')).map((player) => new Plyr(player, {
            controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'],
            settings: ['captions', 'quality', 'speed', 'loop'],
            youtube: {
                noCookie: true,
                rel: 0,
                showinfo: 0,
                iv_load_policy: 3,
                modestbranding: 1,
            },
        }));

        players.forEach(function (player) {

            const $wrapper = $(player.elements.wrapper).parents("[id^=video_]");
            const $overlay = $wrapper.children("[id^=video_poster_]");

            player.on('play', (event) => {
                event.preventDefault();
                $overlay.hide();
            });

            player.on('pause stop', () => {
                // $overlay.show();
            });

            player.on('ended', function (event) {
                event.preventDefault();

                const instance = event.detail.plyr;

                // Next Slide if video ended
                let nextSlide = $wrapper.parents('.slick-slide').next().data('slick-index');
                slider.moveToNextSlide($wrapper.closest('.media-slider'), nextSlide);

                // Stop and go to start
                instance.stop();

                // Show overlay
                $overlay.show();
            });

        });
    },
};
